import { Component } from '@angular/core';

@Component({
    selector: 'footercomonent',
    templateUrl: 'footer.component.html'
})
export class FooterComponent {
    constructor() {
        this.Year = new Date().getFullYear().toString();
    }

    public Year: string;
}
